@if (applicationErrors().length > 0) {
  <div class="td-wb-form__errors">
    @for (error of applicationErrors(); track trackByCode($index, error)) {
      <div [innerText]="getErrorKey(error) | tdWbTranslate: getErrorKeyParams(error)">
      </div>
    }
  </div>
}
